import userPreferencesService from '@/services/userPreferences';

export default {
  data() {
    return {
      autoSaveEnabled: true,
      autoSaveInterval: 15,
      autoSaveTimer: null,
      lastAutoSave: null,
      hasUnsavedChanges: false,
      autoSaveInProgress: false,
    };
  },

  computed: {
    autoSaveStatus() {
      if (this.autoSaveInProgress || this.saveInProgress) {
        return 'Sauvegarde en cours...';
      }
      
      if (!this.autoSaveEnabled) {
        return 'Auto-save désactivé';
      }
      
      if (this.hasUnsavedChanges) {
        if (this.autoSaveTimer && this.lastAutoSave) {
          const nextSave = new Date(this.lastAutoSave.getTime() + this.autoSaveInterval * 60000);
          const now = new Date();
          const diff = Math.ceil((nextSave - now) / 60000);
          if (diff > 0) {
            return `Auto-save dans ${diff} min`;
          }
        }
        return 'Modifications non sauvegardées';
      }
      
      if (this.lastAutoSave) {
        const now = new Date();
        const diff = Math.floor((now - this.lastAutoSave) / 60000);
        if (diff < 1) {
          return 'Sauvegardé à l\'instant';
        } else if (diff === 1) {
          return 'Sauvegardé il y a 1 min';
        } else if (diff < 60) {
          return `Sauvegardé il y a ${diff} min`;
        } else {
          const hours = Math.floor(diff / 60);
          return `Sauvegardé il y a ${hours}h`;
        }
      }
      
      return 'Sauvegardé';
    },

    autoSaveStatusColor() {
      if (this.autoSaveInProgress || this.saveInProgress) {
        return 'info';
      }
      if (!this.autoSaveEnabled) {
        return 'grey';
      }
      if (this.hasUnsavedChanges) {
        return 'orange';
      }
      return 'success';
    }
  },

  methods: {
    loadAutoSavePreferences() {
      this.autoSaveEnabled = userPreferencesService.getPreference('autoSaveEnabled', true);
      this.autoSaveInterval = userPreferencesService.getPreference('autoSaveInterval', 15);
    },

    startAutoSave() {
      this.stopAutoSave();
      
      if (!this.autoSaveEnabled) {
        console.log('[AutoSave] Auto-save is disabled');
        return;
      }

      console.log(`[AutoSave] Starting auto-save timer (${this.autoSaveInterval} minutes)`);
      
      const intervalMs = this.autoSaveInterval * 60 * 1000;
      this.autoSaveTimer = setInterval(() => {
        this.performAutoSave();
      }, intervalMs);
    },

    stopAutoSave() {
      if (this.autoSaveTimer) {
        console.log('[AutoSave] Stopping auto-save timer');
        clearInterval(this.autoSaveTimer);
        this.autoSaveTimer = null;
      }
    },

    async performAutoSave() {
      if (!this.autoSaveEnabled) {
        return;
      }

      if (this.saveInProgress || this.autoSaveInProgress) {
        console.log('[AutoSave] Save already in progress, skipping');
        return;
      }

      if (!this.hasUnsavedChanges) {
        console.log('[AutoSave] No unsaved changes, skipping');
        return;
      }

      if (!this.workspace) {
        console.log('[AutoSave] No workspace loaded, skipping');
        return;
      }

      try {
        console.log('[AutoSave] Performing auto-save...');
        this.autoSaveInProgress = true;
        
        await this.saveProject();
        
        this.lastAutoSave = new Date();
        this.hasUnsavedChanges = false;
        console.log('[AutoSave] Auto-save completed successfully');
        
      } catch (error) {
        console.error('[AutoSave] Auto-save failed:', error);
      } finally {
        this.autoSaveInProgress = false;
      }
    },

    markAsModified() {
      if (!this.hasUnsavedChanges) {
        this.hasUnsavedChanges = true;
        console.log('[AutoSave] Project marked as modified');
      }
    },

    markAsSaved() {
      this.hasUnsavedChanges = false;
      this.lastAutoSave = new Date();
    },

    updateAutoSaveInterval(minutes) {
      this.autoSaveInterval = minutes;
      userPreferencesService.savePreference('autoSaveInterval', minutes);
      
      if (this.autoSaveEnabled) {
        this.startAutoSave();
      }
    },

    toggleAutoSave(enabled) {
      this.autoSaveEnabled = enabled;
      userPreferencesService.savePreference('autoSaveEnabled', enabled);
      
      if (enabled) {
        this.startAutoSave();
      } else {
        this.stopAutoSave();
      }
    }
  },

  beforeDestroy() {
    this.stopAutoSave();
  }
};





